import { render, staticRenderFns } from "./cDocList.vue?vue&type=template&id=5e411d64&scoped=true"
import script from "./cDocList.vue?vue&type=script&lang=js"
export * from "./cDocList.vue?vue&type=script&lang=js"
import style0 from "./cDocList.vue?vue&type=style&index=0&id=5e411d64&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e411d64",
  null
  
)

export default component.exports